<app-loading-spinner name="edit-dialog-loading-image"></app-loading-spinner>
<h1 mat-dialog-title i18n>Edit Image</h1>
<div mat-dialog-content style="height: 100%; width: 100%;">
  <!--<img [src]="imgSrc" #Image [ngClass]="imgCssClass" style="margin: 0!important;">-->
  <image-cropper
    [imageBase64]="imgSrc.base64 ? imgSrc.base64.toString() : null"
    [maintainAspectRatio]="true"
    [aspectRatio]="cropperAspectRatio"
    (imageCropped)="imageCropped($event)"
    (cropperReady)="cropperReady()"
    style="max-width: 100% !important; max-height: 100%; padding: 0;"
    class="absolut-center"
    [canvasRotation]="canvasRotation"
    (imageLoaded)="imageLoaded()"
    (loadImageFailed)="loadImageFailed()"
  >
  </image-cropper>
</div>
<div mat-dialog-actions class="actions">
  <div>
    <button
      mat-button
      matTooltip="Rotate image by 90 degrees counter-clockwise"
      i18n-matTooltip
      matTooltipPosition="above"
      (click)="rotate90CounterClockwise()"
    ><mat-icon>rotate_left</mat-icon></button>
    <button
      mat-button
      matTooltip="Rotate image by 90 degrees clockwise"
      i18n-matTooltip
      matTooltipPosition="above"
      (click)="rotate90Clockwise()"
    ><mat-icon>rotate_right</mat-icon></button>
  </div>
  <div>
  <button
    matTooltip="Close this editor and discard changes"
    i18n-matTooltip
    mat-outline-button
    matTooltipPosition="above"
    mat-button
    cdkFocusInitial
    matDialogClose=""
   i18n>Cancel</button>
  <button
    mat-flat-button
    matTooltip="Close this editor and apply changes"
    i18n-matTooltip
    matTooltipPosition="above"
    (click)="processEditAndCloseDialog()"
    color="primary"
  i18n>Ok</button>
</div>
</div>
